import React, { Fragment } from 'react';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { getPricePerPeriodMarkup } from "../../../../utils/get-price-per-period-markup";
import { Rating } from "../../../elements/Rating";
import { TextPlaceholder } from "../../../elements/TextPlaceholder";
export var getPricePerPeriodAndRatingMarkup = function getPricePerPeriodAndRatingMarkup(isShowingPlaceholder, periodText, pricePerPeriod, pricePerPeriodPrefix, ratingNumber) {
  return isShowingPlaceholder ? React.createElement("div", {
    className: "placeholder-wrapper"
  }, React.createElement(TextPlaceholder, {
    length: "medium"
  }), React.createElement(TextPlaceholder, {
    length: "short"
  })) : React.createElement(Fragment, null, React.createElement(Segment, null, getPricePerPeriodMarkup(pricePerPeriod, pricePerPeriodPrefix, periodText, 'small')), !!ratingNumber && React.createElement(Segment, {
    className: "is-rating"
  }, React.createElement(Rating, {
    iconSize: "tiny",
    ratingNumber: ratingNumber
  })));
};